import React from "react";
import { Icon } from "@iconify/react";

function PlusIconProduct() {
  return (
    <div>
      <Icon icon="circum:square-plus" color="#39bf99" width="30" height="30" />
    </div>
  );
}

export default PlusIconProduct;
